import React from 'react';

const AboutSnippet = () => {
  return (
    <section className="py-8 md:py-12 lg:py-14">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="bg-card rounded-2xl p-6 md:p-10 border border-border">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-4">About Cultaz</h2>
          <p className="text-muted-foreground mb-4">Cultaz helps businesses sell in-person and online. We build tools that work for shops with limited or unreliable internet, while also powering online storefronts for businesses that want to sell on the web.</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <h3 className="font-semibold text-foreground mb-2">Mission</h3>
              <p className="text-muted-foreground">Make simple, reliable point-of-sale and e-commerce tools that let any merchant run and grow their business.</p>
            </div>

            <div>
              <h3 className="font-semibold text-foreground mb-2">Vision</h3>
              <p className="text-muted-foreground">A world where merchants can focus on customers, not technology - online or offline.</p>
            </div>

            <div>
              <h3 className="font-semibold text-foreground mb-2">How it helps</h3>
              <p className="text-muted-foreground">Fast local performance for cashiers, easy online store setup, and optional cloud sync to keep website and store catalogs aligned.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSnippet;
